import { render, staticRenderFns } from "./project-dialog.vue?vue&type=template&id=ca42c6ec&scoped=true"
import script from "./project-dialog.vue?vue&type=script&lang=js"
export * from "./project-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca42c6ec",
  null
  
)

export default component.exports